import PropTypes from 'prop-types'
import { useNetwork } from 'networkProvider'
import { currentUserIsCustomer } from 'lib/currentUserIs'
import withUser from 'client/decorators/withUser'
import VariantText from 'components/UIKit/VariantText'
import MyFacilities from './MyFacilities'
import Dashboard from '~/components/Dashboard'
import Helmet from 'react-helmet'
import { getTitle } from '~/config/titles'

const FacilitiesScreen = props => {
  const network = useNetwork()
  return (
    <>
      <Helmet>
        <title>{getTitle('facilities')}</title>
      </Helmet>
      <Dashboard>
        {!currentUserIsCustomer(props.user) ? (
          <MyFacilities {...props} online={network.online} />
        ) : (
          <VariantText align="center" size="l">
            Please go to the URL you were provided.
          </VariantText>
        )}
      </Dashboard>
    </>
  )
}

FacilitiesScreen.propTypes = {
  user: PropTypes.object,
}

export default withUser(FacilitiesScreen)
